module.exports = __webpack_public_path__ + "static/img/logo.2594d748.png";